<ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true" (close)="close()">
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="('NOTIFICATIONSETTINGS' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
      <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('NOTIFICATIONSETTINGSHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
    </div>
  </ng-template>
  <ng-template #content>

    <div class="d-flex flex-column h-100 p-3">
      <div class="custom-scrollbar overflow-y-auto">
        <app-profile-push-settings [fG]="profilePushForm"></app-profile-push-settings>
      </div>
    </div>

  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-flex align-items-center justify-content-center p-2">
      <app-form-button [text]="'SAVE' | translate" (click)="save()" [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
    </div>
  </ng-template>
</ejs-dialog>
